export const availableToasts = {
  'social-account-add-success': {
    message: 'Cuenta añadida con éxito',
    timeout: 6000,
  },
  'social-account-add-error': {
    message: 'No se ha podido añadir la cuenta',
    color: 'error',
    timeout: 6000,
  },
};

export default {
  availableToasts,
};
